
import { createReducer } from 'redux-act';
import update from 'immutability-helper';

import { dismiss_notification, throw_error } from '../actions';

const TYPE_ID_MAPPING = { err: 'error', inf: 'info' };

export default createReducer({
  [throw_error]: 
  	(state, { message, details }) => 
  		update(state, { 
        error: { $push: [ { id: `err${state.notif}`, message, details, active: true } ] }, 
        notif: { $set: state.notif + 1 },
      }),
  [dismiss_notification]:
  	(state, notificationId) => {
  		const type = TYPE_ID_MAPPING[notificationId.substr(0, 3)];
  		const index = state[type].findIndex(notif => notif.id == notificationId);

  		return update(state, { [type]: { [index]: { active: { $set: false } } } });
  	}
}, {
	notif: 1000,
	error: [],
	info: [],
});
